import { connect } from 'react-redux'

import { IRootState } from '../../common/reducers'
import SiteFooter from '../components/footer/siteFooter'

interface IStateProps {
  usDollarsNotice: any
}

const mapStateToProps = (state: IRootState): IStateProps => {
  const { user } = state

  return {
    usDollarsNotice: user.usDollarsNotice
  }
}

const SiteFooterContainer = connect<IStateProps, void, any, IRootState>(
  mapStateToProps
)(SiteFooter)

export default SiteFooterContainer
